import {
    Avatar,
    Button,
    IconButton,
    Link,
    ListItem,
    ListItemAvatar,
    ListItemText,
    Stack,
    Typography,
} from "@mui/material"
import { ListItemBox } from "lib/@components/ListItemBox"
import Iconify from "minimals-template/components/Iconify"
import { navigate } from "lib/routes/navigate"
import { uniqueId } from "library/database/split-id.mjs"
import { useDialog } from "lib/@hooks/useDialog"
import { OutOfDateDialog } from "routes/asset-register/plugins/schedules-out-of-date/out-of-date-dialog"
import { busyWhile } from "lib/@components/busy/busy-while"
import { updateRegimeSchedulesToLatestVersion } from "routes/asset-register/plugins/schedules-out-of-date/controller/update-regime-schedules-to-latest-version"
import { usePlanRoot } from "lib/use-plan-root"
import { HasInvalidated } from "event-definitions"
import { RegimeDraftLockHide } from "routes/regime/regime-draft-locking/regime-draft-lock-hide"

export function OutOfDateSchedule({ item, last }) {
    const scheduleId = uniqueId(item.scheduleId)
    const planRoot = usePlanRoot()
    const updateDialog = useDialog(<OutOfDateDialog item={item} scheduleId={scheduleId} />, { maxWidth: "sm" })
    return (
        <ListItem data-cy="out-of-date-schedule" divider={!last}>
            <ListItemBox spacing={1}>
                <ListItemAvatar>
                    <Avatar>
                        <Iconify icon="mdi:file-document-outline" />
                    </Avatar>
                </ListItemAvatar>
                <ListItemText
                    primary={
                        <>
                            {item.title}{" "}
                            <Typography variant="caption" color="text.secondary">
                                (#{item.code})
                            </Typography>
                        </>
                    }
                    secondary={item.where}
                />
                <Stack direction="row" spacing={0.5} sx={{ whiteSpace: "nowrap" }}>
                    <Link onClick={go} data-cy="out-of-date-regime-version">
                        <Typography variant="body2">v{item.regimeVersion}</Typography>
                    </Link>
                    <Link onClick={goToSFG20} data-cy="out-of-date-library-version">
                        <Typography variant="body2" color="text.secondary">
                            (SFG20 v{item.sfg20Version})
                        </Typography>
                    </Link>
                </Stack>
                <IconButton
                    size="small"
                    color="primary"
                    onClick={compare}
                    data-cy="out-of-date-compare"
                    aria-label={`compare current v${item.sfg20Version} with v${item.regimeVersion}`}
                >
                    <Iconify icon="ic:twotone-compare" />
                </IconButton>
                <RegimeDraftLockHide>
                    <Button
                        data-cy="update-regime-schedule-button"
                        startIcon={<Iconify icon="material-symbols:deployed-code-update-outline-rounded" />}
                        size="small"
                        color="primary"
                        onClick={update}
                        sx={{ minWidth: "130px" }}
                    >
                        Update Regime
                    </Button>
                </RegimeDraftLockHide>
            </ListItemBox>
        </ListItem>
    )

    async function update() {
        const ids = await updateDialog()
        if (ids) {
            await busyWhile(
                () => updateRegimeSchedulesToLatestVersion(planRoot.id, ids),
                "Updating schedules",
                () => HasInvalidated("schedulesOutOfDateForRegime").wait(3000)
            )
        }
    }

    function compare() {
        navigate(
            `/app/schedules/compare/scheduleHistory!${scheduleId}-${item.sfg20Version}/scheduleHistory!${scheduleId}-${item.regimeVersion}?title=${item.title}&left=Current Version&right=Regime Version`
        )
    }

    function go() {
        navigate(`/app/schedules/${scheduleId}?version=${item.regimeVersion}`)
    }

    function goToSFG20() {
        navigate(`/app/schedules/${scheduleId}?version=${item.sfg20Version}`)
    }
}
